import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Clock, Calendar, ArrowLeft } from 'lucide-react';
import { company, blogPosts } from '../mock';

function PostBody({ body }) {
  return body.map((block, i) => {
    if (block.type === 'h') return <h2 key={`${block.type}-${i}`}>{block.text}</h2>;
    if (block.type === 'list') return (
      <ul key={`${block.type}-${i}`} className="blog-list">
        {block.items.map((it, j) => <li key={`${i}-${j}`}>{it}</li>)}
      </ul>
    );
    return <p key={`${block.type}-${i}`}>{block.text}</p>;
  });
}

export default function BlogPostPage() {
  const { slug } = useParams();
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <main className="blog-page" data-testid="blog-post-missing">
        <section className="blog-index-hero on-dark">
          <div className="wrap">
            <h1>Article not found</h1>
            <p className="lede">The post you&rsquo;re looking for doesn&rsquo;t exist or has moved.</p>
            <Link className="btn btn-gold" to="/blog" style={{ marginTop: '18px' }}><ArrowLeft size={16} /> Back to Blog</Link>
          </div>
        </section>
      </main>
    );
  }

  return (
    <main className="blog-page" data-testid="blog-post-page">
      <article className="blog-article">
        <section className="blog-article-hero" style={{ backgroundImage: `url(${post.image})` }}>
          <div className="blog-article-hero-overlay" />
          <div className="wrap">
            <Link className="blog-back" to="/blog"><ArrowLeft size={15} /> Back to Blog</Link>
            <span className="blog-tag">{post.tag}</span>
            <h1>{post.title}</h1>
            <div className="blog-meta">
              <span><Calendar size={14} /> {post.date}</span>
              <span><Clock size={14} /> {post.readTime}</span>
              <span>By {post.author}</span>
            </div>
          </div>
        </section>

        <section className="blog-body">
          <div className="wrap">
            <p className="blog-lede">{post.excerpt}</p>
            <div className="blog-prose" data-testid="blog-post-content">
              <PostBody body={post.body} />
            </div>

            <div className="blog-cta">
              <div>
                <h3>Need a hand with your plumbing?</h3>
                <p>Our licensed team is a phone call away across Savannah &amp; the Coastal Empire.</p>
              </div>
              <div className="blog-cta-actions">
                <a className="btn btn-gold" href={company.phoneHref} data-testid="blog-call-btn">Call {company.phoneDisplay}</a>
                <Link className="btn btn-outline-dark" to="/blog" data-testid="blog-back-btn"><ArrowLeft size={16} /> All Posts</Link>
              </div>
            </div>
          </div>
        </section>
      </article>
    </main>
  );
}
